<template>
  <div class="property-contents-container">
    <ModelAppearanceTabs v-model:tab="currentTab" :component-width="componentWidth"></ModelAppearanceTabs>
    <v-window v-model="currentTab" style="height: 100%" transition="none" reverse-transition="none">
      <!-- MODEL -->
      <v-window-item value="model">
        <synchronization-choice-model-properties :model="model" @notify-change="emitChange"></synchronization-choice-model-properties>
      </v-window-item>

      <!-- APPEARANCE -->
      <v-window-item value="appearance">
        <synchronization-choice-appearance-properties :model="model" @notify-change="emitChange"></synchronization-choice-appearance-properties>
      </v-window-item>
    </v-window>
  </div>
</template>

<script setup lang="ts">
import { Choice } from "../mvc/choice";
import { Synchronization } from "../mvc/synchronization";
import { computed } from "vue";
import ModelAppearanceTabs from "./ModelAppearanceTabs.vue";
import SynchronizationChoiceModelProperties from "./SynchronizationChoiceModelProperties.vue";
import SynchronizationChoiceAppearanceProperties from "./SynchronizationChoiceAppearanceProperties.vue";

const compProps = defineProps<{
  model: Choice | Synchronization;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tab: any;
  componentWidth: number;
}>();
const emit = defineEmits(["notifyChange", "update:tab"]);

const currentTab = computed({
  get() {
    return compProps.tab;
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  set(tab: any) {
    emit("update:tab", tab);
  },
});

function emitChange(model) {
  emit("notifyChange", model);
}
</script>

